import { InputTextType } from "../Enum/InputTextType";
import { Utils } from "../Utils/Utils";
import Control from "./Control";
export default class InputTextControl extends Control {
    constructor(field, isMain = true, pattern = null) {
        super(field);
        this.type = InputTextType.text;
        this.pattern = null;
        this.isMain = true;
        this.isMain = isMain;
        this.pattern = pattern;
    }
    renderField() {
        if (this.field.isMultilineText) {
            return `<textarea \
            ${this.isMain ? " data-main" : ""}\
            type=${this.type} \
            ${this.pattern ? "pattern='" + this.pattern + "'" : ""}\
            id=${this.field.internalId}${this.isRequired() ? " required" : ""} \
            placeholder="${Utils.isOk(this.field.placeHolder) ? this.field.placeHolder : ""}">${this.initialValue ? this.initialValue : ""}</textarea>`;
        }
        else {
            return `<input \
            ${this.isMain ? " data-main" : ""}\
            type=${this.type} \
            ${this.pattern ? "pattern='" + this.pattern + "'" : ""}\
            id=${this.field.internalId}${this.isRequired() ? " required" : ""} \
            value="${this.initialValue ? this.initialValue : ""}"
            placeholder="${Utils.isOk(this.field.placeHolder) ? this.field.placeHolder : ""}"/>`;
        }
    }
}
